module.exports = __webpack_public_path__ + "img/pds_cursor3.781bab79.svg";